var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 553.65 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #666;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.83,230.1c16.84,0,32.98-6.68,44.89-18.59,11.9-11.91,18.59-28.05,18.59-44.89s-6.69-32.98-18.59-44.89c-11.91-11.9-28.05-18.59-44.89-18.59s-32.98,6.69-44.89,18.59c-11.9,11.91-18.59,28.05-18.59,44.89s6.69,32.98,18.59,44.89c11.91,11.91,28.05,18.59,44.89,18.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.68,357.05h206.3c1.95,.31,3.92-.34,5.32-1.73,1.4-1.4,2.04-3.37,1.73-5.32v-4.41c.24-26.02-9.99-51.05-28.4-69.46-18.41-18.4-43.44-28.63-69.46-28.4h-24.69c-26.02-.23-51.05,10-69.46,28.4-18.41,18.41-28.64,43.44-28.4,69.46v4.41c-.31,1.95,.34,3.92,1.73,5.32,1.4,1.4,3.37,2.04,5.32,1.73h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M553.65,0H0V700H553.65V0Zm-52.9,647.1H52.89V52.9H500.75V647.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.66,426.7H441.69v52.9H121.66v-52.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.66,532.49H441.69v52.9H121.66v-52.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.11a308be2b10fe0730bb0adf102e8c65.svg";
export { ForwardRef as ReactComponent };